'use strict';

const INTERACTION_CONSTANTS = {
  MAIL_SENT: 1,
  MAIL_CLICKED: 2,
  MAIL_OPENED: 3,
  CALLED: 4,
  NO_POTENTIAL: 5,
  APPOINTMENT: 6,
  MAIL_REPLIED: 7,
  MAIL_BOUNCED: 8,
  MAIL_BLOCKED:9,
  MAIL_AUTOREPLIED: 10,
  LINKEDIN_INVITATION_SENT: 11,
  LINKEDIN_MESSAGE_SENT: 12,
  LINKEDIN_INVITATION_ACCEPTED: 13,
};

const INTERACTION_LINKEDIN = [
  INTERACTION_CONSTANTS.LINKEDIN_INVITATION_SENT,
  INTERACTION_CONSTANTS.LINKEDIN_MESSAGE_SENT,
  INTERACTION_CONSTANTS.LINKEDIN_INVITATION_ACCEPTED,
];

const INTERACTION_MAIL = [
  INTERACTION_CONSTANTS.MAIL_SENT,
  INTERACTION_CONSTANTS.MAIL_CLICKED,
  INTERACTION_CONSTANTS.MAIL_OPENED,
  INTERACTION_CONSTANTS.MAIL_REPLIED,
  INTERACTION_CONSTANTS.MAIL_BOUNCED,
  INTERACTION_CONSTANTS.MAIL_BLOCKED,
  INTERACTION_CONSTANTS.MAIL_AUTOREPLIED,
];

export {
  INTERACTION_CONSTANTS,
  INTERACTION_LINKEDIN,
  INTERACTION_MAIL,
};
